import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../../components/layout/AuthLayout";
import { useAuth } from "../../context/AuthContext";

const Login = () => {
  const { signIn } = useAuth(); // Fungsi Masuk dari Sistem Keamanan
  const navigate = useNavigate();

  // --- MEMORI (STATE): Menyimpan data yang diketik ---
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState(""); // Memori untuk pesan kesalahan
  const [loading, setLoading] = useState(false); // Status sedang memproses
  const [showPassword, setShowPassword] = useState(false); // Status mata (buka/tutup password)

  /**
   * --- LOGIKA: Mencatat Ketikan ---
   */
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
    if (error) setError(""); // Hapus pesan error jika pengguna mulai mengetik lagi
  };

  /**
   * --- LOGIKA UTAMA: Proses Masuk (Login) ---
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Memanggil fungsi keamanan untuk memverifikasi Email & Password
      const { error: signInError } = await signIn(
        formData.email,
        formData.password,
      );

      if (signInError) {
        throw signInError;
      }

      // Jika berhasil, arahkan ke Beranda (Dashboard)
      navigate("/dashboard");
    } catch (err) {
      console.error("Login Catch Error:", err);
      // Terjemahan pesan error agar mudah dimengerti pembeli
      setError(err.message || "Kredensial tidak valid.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="w-full max-w-[440px]">
        {/* KARTU LOGIN */}
        <div className="bg-surface-container-lowest ambient-bloom rounded-xl p-10 flex flex-col gap-8">
          {/* Header Identitas Sekolah/Toko */}
          <div className="space-y-2">
            <h1 className="font-headline text-2xl font-bold text-on-surface tracking-tight">
              Sistem Inventaris
            </h1>
            <p className="text-on-surface-variant text-sm">
              Sistem Manajemen Inventaris
            </p>
          </div>

          {/* AREA NOTIFIKASI ERROR */}
          {error && (
            <div className="p-4 bg-error/10 border border-error/20 rounded-lg flex items-center gap-3 text-error text-sm animate-in fade-in slide-in-from-top-1">
              <span className="material-symbols-outlined text-lg">error</span>
              {error}
            </div>
          )}

          {/* FORMULIR INPUT */}
          <form className="flex flex-col gap-5" onSubmit={handleSubmit}>
            {/* Input Email */}
            <div className="space-y-1.5">
              <label
                className="font-label text-xs uppercase tracking-wider font-semibold text-on-surface-variant"
                htmlFor="email"
              >
                Email
              </label>
              <div className="relative group">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 material-symbols-outlined text-outline text-lg group-focus-within:text-primary transition-colors">
                  alternate_email
                </span>
                <input
                  className="w-full pl-12 pr-4 py-3 bg-surface-container-highest border-none rounded-md focus:ring-2 focus:ring-primary-fixed-dim focus:bg-surface-container-lowest transition-all placeholder:text-outline/60 text-on-surface outline-none"
                  id="email"
                  placeholder="your@email.com"
                  type="email"
                  required
                  value={formData.email}
                  onChange={handleChange}
                  disabled={loading}
                />
              </div>
            </div>

            {/* Input Password */}
            <div className="space-y-1.5">
              <div className="flex justify-between items-center">
                <label
                  className="font-label text-xs uppercase tracking-wider font-semibold text-on-surface-variant"
                  htmlFor="password"
                >
                  Password
                </label>
                <Link
                  className="text-[11px] font-semibold text-primary hover:text-primary-container transition-colors uppercase tracking-tight"
                  to="/forgot-password"
                >
                  Lupa Password?
                </Link>
              </div>
              <div className="relative group">
                <span className="absolute left-4 top-1/2 -translate-y-1/2 material-symbols-outlined text-outline text-lg group-focus-within:text-primary transition-colors">
                  lock
                </span>
                <input
                  className="w-full pl-12 pr-4 py-3 bg-surface-container-highest border-none rounded-md focus:ring-2 focus:ring-primary-fixed-dim focus:bg-surface-container-lowest transition-all placeholder:text-outline/60 text-on-surface outline-none"
                  id="password"
                  placeholder="••••••••"
                  type={showPassword ? "text" : "password"}
                  required
                  value={formData.password}
                  onChange={handleChange}
                  disabled={loading}
                />
                {/* Tombol Lihat/Sembunyikan Password */}
                <button
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-outline hover:text-on-surface transition-colors"
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <span className="material-symbols-outlined text-lg">
                    {showPassword ? "visibility" : "visibility_off"}
                  </span>
                </button>
              </div>
            </div>

            {/* Tombol Eksekusi Masuk */}
            <button
              className="mt-2 primary-gradient text-on-primary font-headline font-bold py-3.5 rounded-md hover:opacity-90 active:scale-[0.98] transition-all flex items-center justify-center gap-2 ambient-bloom disabled:opacity-50"
              type="submit"
              disabled={loading}
            >
              {loading ? "Memverifikasi..." : "Masuk"}
              <span className="material-symbols-outlined text-lg">
                arrow_forward
              </span>
            </button>
          </form>

          {/* Garis Pembatas Estetik */}
          <div className="relative flex items-center">
            <div className="flex-grow border-t border-outline-variant opacity-30"></div>
            <span className="flex-shrink mx-4 text-[10px] uppercase tracking-widest text-outline">
              atau
            </span>
            <div className="flex-grow border-t border-outline-variant opacity-30"></div>
          </div>

          {/* Tautan untuk Daftar Akun Baru */}
          <div className="text-center">
            <p className="text-sm text-on-surface-variant">
              Belum punya akun?{" "}
              <Link
                className="text-primary font-semibold hover:underline decoration-2 underline-offset-4"
                to="/register"
              >
                Buat Akun
              </Link>
            </p>
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default Login;
